import api from '../http';
import { AxiosResponse } from 'axios';
import { Product } from '../models/product';


export interface IGetProductsResponse {
    products: Product[]
}

export default class ProductService {
    static async get(): Promise<AxiosResponse<IGetProductsResponse>> {
        return await api.get('products');
    };
};